// @ts-ignore
import { contains } from 'ramda';
import { TThunkAction } from '../../../types/redux';
import { IMultiSuggestResult } from '@cian/geosuggest-widget';
import { EGeoTypes } from '../../../containers/GeoContainer/constants/geoTypes';
import { getByStreets } from './getByStreets';
import { getByTypes } from './getByTypes';
import { IGetGeoSuggestParams } from './types';

export const getGeoSuggest = (params: IGetGeoSuggestParams): TThunkAction<Promise<IMultiSuggestResult>> => {
  return async dispatch => {
    return contains(EGeoTypes.street, params.types) ? dispatch(getByStreets(params)) : dispatch(getByTypes(params));
  };
};
